/**
 * Stable CSS class names for E2E — Customer account history.
 */
export const CAH = {
    page: 'customer-account-history-page',
    gridOuter: 'customer-account-history-page__grid-outer',
    gridInner: 'customer-account-history-page__grid-inner',
    datagrid: 'customer-account-history-page__datagrid',
} as const;

export const cahCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
